<template>
  <div class="main main--hasHeader main--hasFooter">
      <div class="customContainer">
        <h2 class="members__headline">利用規約</h2>
        <div class="members-list">
          <p class="members-list__description">規約に関する説明文章が入ります。規約に関する説明文章が入ります。規約に関する説明文章が入ります。規約に関する説明文章が入ります。規約に関する説明文章が入ります。</p>
          <ul class="members-list__ul01">
            <li class="members-list__li01">規約に関する説明文章が入ります。規約に関する説明文章が入ります。規約に関する説明文章が入ります。
              <ul class="members-list__ul02">
                <li class="members-list__li02">規約に関する説明文章が入ります。規約に関する説明文章が入ります。規約に関する説明文章が入ります。</li>
                <li class="members-list__li02">規約に関する説明文章が入ります。規約に関する説明文章が入ります。規約に関する説明文章が入ります。</li>
              </ul>
            </li>
            <li class="members-list__li01">規約に関する説明文章が入ります。規約に関する説明文章が入ります。規約に関する説明文章が入ります。</li>
            <li class="members-list__li01">規約に関する説明文章が入ります。規約に関する説明文章が入ります。規約に関する説明文章が入ります。</li>
            <li class="members-list__li01">規約に関する説明文章が入ります。規約に関する説明文章が入ります。規約に関する説明文章が入ります。</li>
          </ul>
          <ol class="members-list__ol03">
            <li class="members-list__li03">規約に関する説明文章が入ります。規約に関する説明文章が入ります。規約に関する説明文章が入ります。
              <ol class="members-list__ol04">
                <li class="members-list__li04">規約に関する説明文章が入ります。規約に関する説明文章が入ります。規約に関する説明文章が入ります。</li>
                <li class="members-list__li04">規約に関する説明文章が入ります。規約に関する説明文章が入ります。規約に関する説明文章が入ります。</li>
              </ol>
            </li>
            <li class="members-list__li03">規約に関する説明文章が入ります。規約に関する説明文章が入ります。規約に関する説明文章が入ります。</li>
            <li class="members-list__li03">規約に関する説明文章が入ります。規約に関する説明文章が入ります。規約に関する説明文章が入ります。</li>
            <li class="members-list__li03">規約に関する説明文章が入ります。規約に関する説明文章が入ります。規約に関する説明文章が入ります。</li>
          </ol>
        </div>
      </div>
    </div>
</template>
<script>
// import { mapState } from 'vuex'
export default {
  name: 'UserKiyakuView',
  data: function () {
      return {}
  },
  components: {
  },
  methods: {
  },
  computed: {
    // customer: state => state.apidata.customer,
  },
  created () {
  },
  mounted: function(){
  },
}
</script>
